export const TARGET_ACCENT = "#f59e0b";
